export function intersectArrays<T>(...arrays: T[][]): T[] {
    if (arrays.length === 0) return [];

    arrays.sort((a, b) => a.length - b.length);
    const [first, ...rest] = arrays;
    const result: T[] = [];
    const seen = new Set<T>();
    const sets = rest.map((arr) => new Set(arr));

    for (const value of first) {
        if (!seen.has(value) && sets.every((set) => set.has(value))) {
            seen.add(value);
            result.push(value);
        }
    }

    return result;
}
